import { useState, useEffect } from 'react';
import api from '../../lib/api';
import { Card } from '../../components/ui/card';
import { Users, BookOpen, FileText, HelpCircle, ShoppingCart, Tag, IndianRupee } from 'lucide-react';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/dashboard').then(r => setStats(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-4 border-[#7551e8] border-t-transparent rounded-full animate-spin" /></div>;

  const cards = [
    { label: 'Total Students', value: stats?.total_students || 0, icon: Users, color: 'bg-[#F4F0FF] text-[#7551e8]' },
    { label: 'Test Series', value: stats?.total_series || 0, icon: BookOpen, color: 'bg-blue-50 text-blue-600' },
    { label: 'Total Tests', value: stats?.total_tests || 0, icon: FileText, color: 'bg-green-50 text-green-600' },
    { label: 'Total Questions', value: stats?.total_questions || 0, icon: HelpCircle, color: 'bg-amber-50 text-amber-600' },
    { label: 'Total Orders', value: stats?.total_orders || 0, icon: ShoppingCart, color: 'bg-pink-50 text-pink-600' },
    { label: 'Coupons', value: stats?.total_coupons || 0, icon: Tag, color: 'bg-cyan-50 text-cyan-600' },
    { label: 'Revenue', value: `Rs.${stats?.total_revenue || 0}`, icon: IndianRupee, color: 'bg-emerald-50 text-emerald-600' },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-['Outfit'] text-2xl font-semibold text-[#0A0A0A] mb-6">Dashboard Overview</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {cards.map(c => (
          <Card key={c.label} className="p-5 border border-zinc-200 bg-white" data-testid={`admin-stat-${c.label.toLowerCase().replace(/\s+/g, '-')}`}>
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${c.color}`}>
                <c.icon size={18} />
              </div>
              <div>
                <p className="text-xs text-[#52525B] font-medium">{c.label}</p>
                <p className="font-['Outfit'] text-2xl font-semibold">{c.value}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
